/* tslint:disable */
/* eslint-disable */
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PresignedReportingDashboardDTO,
  ReportingDashboardDTO,
} from '../models/index';
import {
    PresignedReportingDashboardDTOFromJSON,
    PresignedReportingDashboardDTOToJSON,
    ReportingDashboardDTOFromJSON,
    ReportingDashboardDTOToJSON,
} from '../models/index';

export interface GetPresignedReportingDashboardRequest {
    dashboardAlias: string;
    theme?: GetPresignedReportingDashboardThemeEnum;
}

/**
 * 
 */
export class SigmaApi extends runtime.BaseAPI {

    /**
     * Get Presigned Reporting Dashboard
     */
    async getPresignedReportingDashboardRaw(requestParameters: GetPresignedReportingDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresignedReportingDashboardDTO>> {
        if (requestParameters['dashboardAlias'] == null) {
            throw new runtime.RequiredError(
                'dashboardAlias',
                'Required parameter "dashboardAlias" was null or undefined when calling getPresignedReportingDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['theme'] != null) {
            queryParameters['theme'] = requestParameters['theme'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sigma/dashboards/{dashboardAlias}/presigned`.replace(`{${"dashboardAlias"}}`, encodeURIComponent(String(requestParameters['dashboardAlias']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresignedReportingDashboardDTOFromJSON(jsonValue));
    }

    /**
     * Get Presigned Reporting Dashboard
     */
    async getPresignedReportingDashboard(requestParameters: GetPresignedReportingDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresignedReportingDashboardDTO> {
        const response = await this.getPresignedReportingDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Reporting Dashboards
     */
    async getReportingDashboardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReportingDashboardDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/sigma/dashboards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReportingDashboardDTOFromJSON));
    }

    /**
     * Get Reporting Dashboards
     */
    async getReportingDashboards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReportingDashboardDTO>> {
        const response = await this.getReportingDashboardsRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetPresignedReportingDashboardThemeEnum = {
    Light: 'Light',
    Dark: 'Dark'
} as const;
export type GetPresignedReportingDashboardThemeEnum = typeof GetPresignedReportingDashboardThemeEnum[keyof typeof GetPresignedReportingDashboardThemeEnum];
